import { Grid2 } from "@mui/material";
import FormFields from "pages/components/FormFields";
import Section from "pages/components/Section";
import Countries from "pages/config/Countries";

export default function Contact(props: any) {
  const { values, handleInputChange, isMobile, formatErrorObject, errors } =
    props;

  const phonePrefix = Countries[values.country].phonePrefix;

  return (
    <Section title={"contact"}>
      <Grid2
        width={"100%"}
        gap={2}
        display="grid"
        gridTemplateColumns={isMobile ? "1fr" : "repeat(3, 1fr)"}
      >
        <FormFields.Email
          name="email"
          value={values.email}
          onChange={handleInputChange}
          required
          {...formatErrorObject(errors.email)}
        />
        <FormFields.Phone
          name="phone"
          value={values.phone}
          prefix={phonePrefix}
          onChange={handleInputChange}
          required
          {...formatErrorObject(errors.phone)}
        />
        <FormFields.Phone
          name="mobile"
          value={values.mobile}
          prefix={phonePrefix}
          onChange={handleInputChange}
          mobile={1}
          required
          {...formatErrorObject(errors.mobile)}
        />
      </Grid2>
    </Section>
  );
}
